import { render } from "./GamerEarnings.vue?vue&type=template&id=0727c494&scoped=true"
import script from "./GamerEarnings.vue?vue&type=script&lang=js"
export * from "./GamerEarnings.vue?vue&type=script&lang=js"

import "./GamerEarnings.vue?vue&type=style&index=0&id=0727c494&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0727c494"

export default script